import React from 'react';
import { a as __rest, l as loadable$2, _ as __assign, I as Icon } from './loadable.esm-8884282c.js';
import UnavailableIcon from './UnavailableIcon-0a47fca9.js';
import { P as ProxyCartIcon } from './ProxyCartIcon-3d81c7ae.js';
import { P as ProxyCloseIcon } from './ProxyCloseIcon-e613dfa0.js';
import { P as ProxyLocationPinIcon } from './ProxyLocationPinIcon-b506587e.js';
import { P as ProxyPhoneIcon } from './ProxyPhoneIcon-4dcfbc06.js';
import { P as ProxyChatIcon } from './ProxyChatIcon-e068ddda.js';
import { P as ProxyGlobeIcon } from './ProxyGlobeIcon-653302de.js';
import ExternalLinkIcon from './ExternalLinkIcon-fc5de91e.js';
import { P as ProxySearchIcon } from './ProxySearchIcon-e36fae30.js';
import { P as ProxyToggleIcon } from './ProxyToggleIcon-4f25b044.js';
import { P as ProxyUserIcon } from './ProxyUserIcon-22bf0acf.js';
import { P as ProxyTruckIcon } from './ProxyTruckIcon-3a63aa59.js';
import { P as ProxyTagIcon } from './ProxyTagIcon-6488843a.js';
import { P as ProxyTarragonIcon } from './ProxyTarragonIcon-a7a64e50.js';
import { P as ProxyReturnsIcon } from './ProxyReturnsIcon-0bdeac77.js';
import { P as ProxyYoutubeIcon } from './ProxyYoutubeIcon-153a7f13.js';
import { P as ProxyTwitterIcon } from './ProxyTwitterIcon-b2ccfdaa.js';
import { P as ProxyInstagramIcon } from './ProxyInstagramIcon-a1e2dc78.js';
import { P as ProxyFacebookIcon } from './ProxyFacebookIcon-d95ef1a1.js';
import { P as ProxyBrightIcon } from './ProxyBrightIcon-5cab3d4e.js';
import { P as ProxyChalkyIcon } from './ProxyChalkyIcon-818edfb5.js';
import { P as ProxyChewyIcon } from './ProxyChewyIcon-cc4d3d22.js';
import { P as ProxyCrispIcon } from './ProxyCrispIcon-2b7afca5.js';
import { P as ProxyFineIcon } from './ProxyFineIcon-a1abbfbc.js';
import { P as ProxyFirmIcon } from './ProxyFirmIcon-c6251fd7.js';
import { P as ProxyFlatIcon } from './ProxyFlatIcon-cb255880.js';
import { P as ProxyFreshIcon } from './ProxyFreshIcon-2e547f03.js';
import { P as ProxyGrippyIcon } from './ProxyGrippyIcon-8354f9f5.js';
import { P as ProxyLivelyIcon } from './ProxyLivelyIcon-be2ffe0b.js';
import { P as ProxyMellowIcon } from './ProxyMellowIcon-cba18801.js';
import { P as ProxyMouthWateringIcon } from './ProxyMouthWateringIcon-388b4d22.js';
import { P as ProxyRacyIcon } from './ProxyRacyIcon-ed5845cc.js';
import { P as ProxyRefreshingIcon } from './ProxyRefreshingIcon-5616da98.js';
import { P as ProxyRoundIcon } from './ProxyRoundIcon-c6f746f9.js';
import { P as ProxyRusticIcon } from './ProxyRusticIcon-ca3589fb.js';
import { P as ProxySilkyIcon } from './ProxySilkyIcon-599afe4e.js';
import { P as ProxySmoothIcon } from './ProxySmoothIcon-441192a0.js';
import { P as ProxySoftIcon } from './ProxySoftIcon-d9de88f2.js';
import { P as ProxyTexturedIcon } from './ProxyTexturedIcon-9816049f.js';
import { P as ProxyVelvetyIcon } from './ProxyVelvetyIcon-fbff3cf6.js';
import { P as ProxyVibrantIcon } from './ProxyVibrantIcon-b7ea2dee.js';
import { P as ProxyZestyIcon } from './ProxyZestyIcon-7adf6b36.js';
import { P as ProxyZippyIcon } from './ProxyZippyIcon-9ec7ed71.js';
import { P as ProxyFullBodiedIcon } from './ProxyFullBodiedIcon-46a66516.js';
import { P as ProxyMediumBodiedIcon } from './ProxyMediumBodiedIcon-54a4e24f.js';
import { P as ProxyLightBodiedIcon } from './ProxyLightBodiedIcon-1f66b9cc.js';
import { P as ProxyBoldIcon } from './ProxyBoldIcon-bc63da4f.js';
import { P as ProxyBrambleIcon } from './ProxyBrambleIcon-c36d138e.js';
import { P as ProxyConcentratedIcon } from './ProxyConcentratedIcon-216c124d.js';
import { P as ProxyDeepIcon } from './ProxyDeepIcon-c20e06e0.js';
import { P as ProxyDelicateIcon } from './ProxyDelicateIcon-bb65468b.js';
import { P as ProxyElegantIcon } from './ProxyElegantIcon-c3664aa0.js';
import { P as ProxyEtherealIcon } from './ProxyEtherealIcon-27fec2a5.js';
import { P as ProxyIntenseIcon } from './ProxyIntenseIcon-0953227d.js';
import { P as ProxyOpulentIcon } from './ProxyOpulentIcon-3cbdaacd.js';
import { P as ProxyPowerfulIcon } from './ProxyPowerfulIcon-0e1ca47b.js';
import { P as ProxyRefinedIcon } from './ProxyRefinedIcon-7ea84eeb.js';
import { P as ProxyRestrainedIcon } from './ProxyRestrainedIcon-1637d579.js';
import { P as ProxyRichIcon } from './ProxyRichIcon-714cec1d.js';
import { P as ProxyRobustIcon } from './ProxyRobustIcon-836ec27c.js';
import { P as ProxyAllspiceIcon } from './ProxyAllspiceIcon-8278c162.js';
import { P as ProxyAlmondIcon } from './ProxyAlmondIcon-8a9e292a.js';
import { P as ProxyAniseedIcon } from './ProxyAniseedIcon-5e3e67b6.js';
import { P as ProxyAppleIcon } from './ProxyAppleIcon-848ef018.js';
import { P as ProxyApricotIcon } from './ProxyApricotIcon-7d87e525.js';
import { P as ProxyAsparagusIcon } from './ProxyAsparagusIcon-be6ce775.js';
import { P as ProxyBananaIcon } from './ProxyBananaIcon-c7e8fb1a.js';
import { P as ProxyBasilIcon } from './ProxyBasilIcon-aa602725.js';
import { P as ProxyBayLeafIcon } from './ProxyBayLeafIcon-3a2556f7.js';
import { P as ProxyBerriesIcon } from './ProxyBerriesIcon-9eb02deb.js';
import { P as ProxyBellIcon } from './ProxyBellIcon-ac396c9d.js';
import { P as ProxyBellRungIcon } from './ProxyBellRungIcon-971c0915.js';
import { P as ProxyBiscuityIcon } from './ProxyBiscuityIcon-88a8edc0.js';
import { P as ProxyBlackCherryIcon } from './ProxyBlackCherryIcon-30aa92cd.js';
import { P as ProxyBlackOliveIcon } from './ProxyBlackOliveIcon-b241f41d.js';
import { P as ProxyBlackberryIcon } from './ProxyBlackberryIcon-ce1b50b2.js';
import { P as ProxyBlackcurrantIcon } from './ProxyBlackcurrantIcon-a29f1117.js';
import { P as ProxyBloodPlumIcon } from './ProxyBloodPlumIcon-36b2c680.js';
import { P as ProxyBlossomsIcon } from './ProxyBlossomsIcon-b6b24848.js';
import { P as ProxyBlueberryIcon } from './ProxyBlueberryIcon-d8efb573.js';
import { P as ProxyBoiledLolliesIcon } from './ProxyBoiledLolliesIcon-16401adb.js';
import { P as ProxyBreadIcon } from './ProxyBreadIcon-91cceb63.js';
import { P as ProxyBrinyIcon } from './ProxyBrinyIcon-b7967417.js';
import { P as ProxyBriaryIcon } from './ProxyBriaryIcon-b02836c3.js';
import { P as ProxyBriocheIcon } from './ProxyBriocheIcon-0ace1078.js';
import { P as ProxyButterscotchIcon } from './ProxyButterscotchIcon-9afbb44b.js';
import { P as ProxyButteryIcon } from './ProxyButteryIcon-bead9a29.js';
import { P as ProxyCandiedIcon } from './ProxyCandiedIcon-8ccf1ca5.js';
import { P as ProxyCapsicumIcon } from './ProxyCapsicumIcon-d0763ffa.js';
import { P as ProxyCaramelIcon } from './ProxyCaramelIcon-db58409a.js';
import { P as ProxyCashewIcon } from './ProxyCashewIcon-abae6a7f.js';
import { P as ProxyCassisIcon } from './ProxyCassisIcon-a1b753f8.js';
import { P as ProxyCedarIcon } from './ProxyCedarIcon-369152b9.js';
import { P as ProxyCharredIcon } from './ProxyCharredIcon-d183cabc.js';
import { P as ProxyCherryIcon } from './ProxyCherryIcon-e310cdc0.js';
import { P as ProxyChestnutIcon } from './ProxyChestnutIcon-bb4f6b09.js';
import { P as ProxyChocolateIcon } from './ProxyChocolateIcon-b4914b21.js';
import { P as ProxyCigarboxIcon } from './ProxyCigarboxIcon-cdafd23f.js';
import { P as ProxyCinnamonIcon } from './ProxyCinnamonIcon-59a2790f.js';
import { P as ProxyCitrusIcon } from './ProxyCitrusIcon-d6cf533a.js';
import { P as ProxyClovesIcon } from './ProxyClovesIcon-ed7aedf6.js';
import { P as ProxyCocoaIcon } from './ProxyCocoaIcon-99ee6b68.js';
import { P as ProxyCoconutIcon } from './ProxyCoconutIcon-4d54ab36.js';
import { P as ProxyColaIcon } from './ProxyColaIcon-318d349e.js';
import { P as ProxyCoffeeIcon } from './ProxyCoffeeIcon-0bfca609.js';
import { P as ProxyCranberryIcon } from './ProxyCranberryIcon-29eb8acd.js';
import { P as ProxyCreamyIcon } from './ProxyCreamyIcon-9acb70a8.js';
import { P as ProxyCucumberIcon } from './ProxyCucumberIcon-25d33ee7.js';
import { P as ProxyCumquatIcon } from './ProxyCumquatIcon-9b7d0407.js';
import { P as ProxyDarkChocolateIcon } from './ProxyDarkChocolateIcon-046b3ad6.js';
import { P as ProxyDillIcon } from './ProxyDillIcon-0cbed5ff.js';
import { P as ProxyDriedApricotIcon } from './ProxyDriedApricotIcon-16008dca.js';
import { P as ProxyDriedFlowersIcon } from './ProxyDriedFlowersIcon-d3240add.js';
import { P as ProxyEarthyIcon } from './ProxyEarthyIcon-4a0546ca.js';
import { P as ProxyElderflowerIcon } from './ProxyElderflowerIcon-afbd6f71.js';
import { P as ProxyEucalyptusIcon } from './ProxyEucalyptusIcon-d9327845.js';
import { P as ProxyFeijoaIcon } from './ProxyFeijoaIcon-0e9c3d4f.js';
import { P as ProxyFennelIcon } from './ProxyFennelIcon-d5ddd7cc.js';
import { P as ProxyFigIcon } from './ProxyFigIcon-01d2baeb.js';
import { P as ProxyFlintyIcon } from './ProxyFlintyIcon-a31d1776.js';
import { P as ProxyFloralIcon } from './ProxyFloralIcon-132077b7.js';
import { P as ProxyForestFloorIcon } from './ProxyForestFloorIcon-58351055.js';
import { P as ProxyFruitSaladIcon } from './ProxyFruitSaladIcon-a0a0e5a9.js';
import { P as ProxyFruitcakeIcon } from './ProxyFruitcakeIcon-064988eb.js';
import { P as ProxyFruityIcon } from './ProxyFruityIcon-e34afb8e.js';
import { P as ProxyGameyIcon } from './ProxyGameyIcon-2025b146.js';
import { P as ProxyGeraniumIcon } from './ProxyGeraniumIcon-f3be5125.js';
import { P as ProxyGingerbreadIcon } from './ProxyGingerbreadIcon-517a8790.js';
import { P as ProxyGooseberryIcon } from './ProxyGooseberryIcon-2fd7ec78.js';
import { P as ProxyGrapefruitIcon } from './ProxyGrapefruitIcon-535dfa29.js';
import { P as ProxyGrassyIcon } from './ProxyGrassyIcon-6d915368.js';
import { P as ProxyGreenAppleIcon } from './ProxyGreenAppleIcon-21d665d7.js';
import { P as ProxyGreenOliveIcon } from './ProxyGreenOliveIcon-ffb0080f.js';
import { P as ProxyGuavaIcon } from './ProxyGuavaIcon-08644fcf.js';
import { P as ProxyHayIcon } from './ProxyHayIcon-34528d38.js';
import { P as ProxyHazelnutIcon } from './ProxyHazelnutIcon-ba658ef0.js';
import { P as ProxyHerbaceousIcon } from './ProxyHerbaceousIcon-617d0df2.js';
import { P as ProxyHoneyIcon } from './ProxyHoneyIcon-4f4b69a1.js';
import { P as ProxyHoneysuckleIcon } from './ProxyHoneysuckleIcon-bb55b7ae.js';
import { P as ProxyHotIcon } from './ProxyHotIcon-bd75ab68.js';
import { P as ProxyJammyIcon } from './ProxyJammyIcon-7a66b317.js';
import { P as ProxyJasmineIcon } from './ProxyJasmineIcon-671bf3f6.js';
import { P as ProxyJubieIcon } from './ProxyJubieIcon-17c13fba.js';
import { P as ProxyKaffirLimeIcon } from './ProxyKaffirLimeIcon-3f5b0ae9.js';
import { P as ProxyKeroseneIcon } from './ProxyKeroseneIcon-2f90a7d0.js';
import { P as ProxyKiwiFruitIcon } from './ProxyKiwiFruitIcon-2c7ce8db.js';
import { P as ProxyLanolinIcon } from './ProxyLanolinIcon-f2ab0a88.js';
import { P as ProxyLaserLikeIcon } from './ProxyLaserLikeIcon-2a9cf337.js';
import { P as ProxyLavenderIcon } from './ProxyLavenderIcon-a05b3571.js';
import { P as ProxyLeatherIcon } from './ProxyLeatherIcon-a835a97b.js';
import { P as ProxyLeesyIcon } from './ProxyLeesyIcon-f81cf280.js';
import { P as ProxyLemonZestIcon } from './ProxyLemonZestIcon-24f20385.js';
import { P as ProxyLemonIcon } from './ProxyLemonIcon-dc5c98fe.js';
import { P as ProxyLemonCurdIcon } from './ProxyLemonCurdIcon-f0e47847.js';
import { P as ProxyLicoriceIcon } from './ProxyLicoriceIcon-4eff2b5e.js';
import { P as ProxyLimeIcon } from './ProxyLimeIcon-30573c81.js';
import { P as ProxyLimeCordialIcon } from './ProxyLimeCordialIcon-38e1422f.js';
import { P as ProxyLycheeIcon } from './ProxyLycheeIcon-593d7cd2.js';
import { P as ProxyMaltyIcon } from './ProxyMaltyIcon-a09ce216.js';
import { P as ProxyMandarinIcon } from './ProxyMandarinIcon-5bb5c5c7.js';
import { P as ProxyMangoIcon } from './ProxyMangoIcon-9d59bed6.js';
import { P as ProxyMarmaladeIcon } from './ProxyMarmaladeIcon-e2a5f525.js';
import { P as ProxyMarzipanIcon } from './ProxyMarzipanIcon-87dbbfb6.js';
import { P as ProxyMeatyIcon } from './ProxyMeatyIcon-0014c5ef.js';
import { P as ProxyMedicinalIcon } from './ProxyMedicinalIcon-be1f2255.js';
import { P as ProxyMelonIcon } from './ProxyMelonIcon-b49fccaf.js';
import { P as ProxyMentholIcon } from './ProxyMentholIcon-9e6c8ec1.js';
import { P as ProxyMinerallyIcon } from './ProxyMinerallyIcon-e1000f6c.js';
import { P as ProxyMintIcon } from './ProxyMintIcon-84b6c59f.js';
import { P as ProxyMochaIcon } from './ProxyMochaIcon-900a9594.js';
import { P as ProxyMolassesIcon } from './ProxyMolassesIcon-51b9a78c.js';
import { P as ProxyMossyIcon } from './ProxyMossyIcon-2ca34258.js';
import { P as ProxyMulberryIcon } from './ProxyMulberryIcon-95ede267.js';
import { P as ProxyMushroomIcon } from './ProxyMushroomIcon-c55c85d2.js';
import { P as ProxyMuskIcon } from './ProxyMuskIcon-eab59ee4.js';
import { P as ProxyNectarineIcon } from './ProxyNectarineIcon-8c57d0ec.js';
import { P as ProxyNettlesIcon } from './ProxyNettlesIcon-fce89c6b.js';
import { P as ProxyNougatIcon } from './ProxyNougatIcon-dc05b1d9.js';
import { P as ProxyNutmegIcon } from './ProxyNutmegIcon-15db25f8.js';
import { P as ProxyNuttyIcon } from './ProxyNuttyIcon-041a1b45.js';
import { P as ProxyOakyIcon } from './ProxyOakyIcon-a4fb9f34.js';
import { P as ProxyOffDryIcon } from './ProxyOffDryIcon-02ab5f93.js';
import { P as ProxyOrangePeelIcon } from './ProxyOrangePeelIcon-810bca12.js';
import { P as ProxyOrangeBlossomIcon } from './ProxyOrangeBlossomIcon-e5418193.js';
import { P as ProxyOrangeIcon } from './ProxyOrangeIcon-d20bae3d.js';
import { P as ProxyOysterShellIcon } from './ProxyOysterShellIcon-d9be5a45.js';
import { P as ProxyPassionfruitIcon } from './ProxyPassionfruitIcon-5bada1cb.js';
import { P as ProxyPeachIcon } from './ProxyPeachIcon-0ca72b68.js';
import { P as ProxyPearIcon } from './ProxyPearIcon-5df118ad.js';
import { P as ProxyPeasIcon } from './ProxyPeasIcon-41a8a1d6.js';
import { P as ProxyPencilShavingsIcon } from './ProxyPencilShavingsIcon-0423594d.js';
import { P as ProxyPepperIcon } from './ProxyPepperIcon-6ec97851.js';
import { P as ProxyPeppermintIcon } from './ProxyPeppermintIcon-0a2e1fb6.js';
import { P as ProxyPerfumedIcon } from './ProxyPerfumedIcon-ea6b7d0e.js';
import { P as ProxyPineIcon } from './ProxyPineIcon-dacf62bd.js';
import { P as ProxyPineappleIcon } from './ProxyPineappleIcon-72bff3e8.js';
import { P as ProxyPithyIcon } from './ProxyPithyIcon-726f6f1e.js';
import { P as ProxyPlumIcon } from './ProxyPlumIcon-152f4897.js';
import { P as ProxyPopcornIcon } from './ProxyPopcornIcon-b30c3233.js';
import { P as ProxyPotpourriIcon } from './ProxyPotpourriIcon-0ff26912.js';
import { P as ProxyPrunesIcon } from './ProxyPrunesIcon-14454cc1.js';
import { P as ProxyQuinceIcon } from './ProxyQuinceIcon-c7f7230d.js';
import { P as ProxyRaisinIcon } from './ProxyRaisinIcon-172c6865.js';
import { P as ProxyRaspberryIcon } from './ProxyRaspberryIcon-0b8d906b.js';
import { P as ProxyRedcurrantIcon } from './ProxyRedcurrantIcon-9572a72c.js';
import { P as ProxyRhubarbIcon } from './ProxyRhubarbIcon-4f08cbf3.js';
import { P as ProxyRockmelonIcon } from './ProxyRockmelonIcon-ef9e43d6.js';
import { P as ProxyRosePetalIcon } from './ProxyRosePetalIcon-a0e258ac.js';
import { P as ProxySaffronIcon } from './ProxySaffronIcon-5e2574bc.js';
import { P as ProxySaltyIcon } from './ProxySaltyIcon-a455692f.js';
import { P as ProxySageIcon } from './ProxySageIcon-b649e2eb.js';
import { P as ProxySandalwoodIcon } from './ProxySandalwoodIcon-33d67ddd.js';
import { P as ProxySavouryIcon } from './ProxySavouryIcon-6a9264e2.js';
import { P as ProxySeaSprayIcon } from './ProxySeaSprayIcon-a548add6.js';
import { P as ProxySlateIcon } from './ProxySlateIcon-2f8e43db.js';
import { P as ProxySmokyIcon } from './ProxySmokyIcon-587a0ac9.js';
import { P as ProxySourCherryIcon } from './ProxySourCherryIcon-be3ae6e1.js';
import { P as ProxySoyIcon } from './ProxySoyIcon-bcf28c98.js';
import { P as ProxySpearmintIcon } from './ProxySpearmintIcon-dbc20322.js';
import { P as ProxySpiceIcon } from './ProxySpiceIcon-25a727fa.js';
import { P as ProxySpiceboxIcon } from './ProxySpiceboxIcon-83e7fd50.js';
import { P as ProxyStarAniseIcon } from './ProxyStarAniseIcon-94898059.js';
import { P as ProxyStewedFruitsIcon } from './ProxyStewedFruitsIcon-04b21214.js';
import { P as ProxyStrawberryIcon } from './ProxyStrawberryIcon-a35d66d5.js';
import { P as ProxyStruckMatchIcon } from './ProxyStruckMatchIcon-96463308.js';
import { P as ProxyStructuredIcon } from './ProxyStructuredIcon-7815ee22.js';
import { P as ProxySweetIcon } from './ProxySweetIcon-936a2130.js';
import { P as ProxyTarryIcon } from './ProxyTarryIcon-6c92edab.js';
import { P as ProxyTeaIcon } from './ProxyTeaIcon-20dc2bda.js';
import { P as ProxyTeaLeafIcon } from './ProxyTeaLeafIcon-1dedbc88.js';
import { P as ProxyTempIcon } from './ProxyTempIcon-5d872359.js';
import { P as ProxyThymeIcon } from './ProxyThymeIcon-755ce4fe.js';
import { P as ProxyToastIcon } from './ProxyToastIcon-716dad14.js';
import { P as ProxyTobaccoIcon } from './ProxyTobaccoIcon-fb2086a9.js';
import { P as ProxyToffeeIcon } from './ProxyToffeeIcon-2e5691ed.js';
import { P as ProxyTomatoLeafIcon } from './ProxyTomatoLeafIcon-8dea37d6.js';
import { P as ProxyTreacleIcon } from './ProxyTreacleIcon-8447fd2a.js';
import { P as ProxyTropicalFruitIcon } from './ProxyTropicalFruitIcon-16193c57.js';
import { P as ProxyTruffleIcon } from './ProxyTruffleIcon-2f5cc5bb.js';
import { P as ProxyUmamiIcon } from './ProxyUmamiIcon-b667f0fc.js';
import { P as ProxyUnoakedIcon } from './ProxyUnoakedIcon-b707e031.js';
import { P as ProxyVanillaIcon } from './ProxyVanillaIcon-a0f7e2e1.js';
import { P as ProxyVegemiteIcon } from './ProxyVegemiteIcon-07fba6d3.js';
import { P as ProxyVegetativeIcon } from './ProxyVegetativeIcon-4a72bc8f.js';
import { P as ProxyVioletsIcon } from './ProxyVioletsIcon-960ca4e4.js';
import { P as ProxyWalnutIcon } from './ProxyWalnutIcon-6411a678.js';
import { P as ProxyWhitePeachIcon } from './ProxyWhitePeachIcon-e8f96cb3.js';
import { P as ProxyWhitePepperIcon } from './ProxyWhitePepperIcon-dc61cb95.js';
import { P as ProxyWildBerriesIcon } from './ProxyWildBerriesIcon-b88301f4.js';
import { P as ProxyWoodyIcon } from './ProxyWoodyIcon-18cdb8e3.js';
import { P as ProxyYeastyIcon } from './ProxyYeastyIcon-1837793e.js';
import { P as ProxyYoghurtIcon } from './ProxyYoghurtIcon-582e1d93.js';
import { P as ProxyPoints90Icon } from './ProxyPoints90Icon-cb7964c7.js';
import { P as ProxyPoints91Icon } from './ProxyPoints91Icon-b303054a.js';
import { P as ProxyPoints92Icon } from './ProxyPoints92Icon-477bf83c.js';
import { P as ProxyPoints93Icon } from './ProxyPoints93Icon-eedd461e.js';
import { P as ProxyPoints94Icon } from './ProxyPoints94Icon-dac47295.js';
import { P as ProxyPoints95Icon } from './ProxyPoints95Icon-42a5bb4e.js';
import { P as ProxyPoints96Icon } from './ProxyPoints96Icon-4cb80ce8.js';
import { P as ProxyPoints97Icon } from './ProxyPoints97Icon-f0fcb6ce.js';
import { P as ProxyPoints98Icon } from './ProxyPoints98Icon-b5606b4a.js';
import { P as ProxyPoints99Icon } from './ProxyPoints99Icon-53cc1d97.js';
import { P as ProxyPoints100Icon } from './ProxyPoints100Icon-0a8bff43.js';
import { P as ProxyGoldMedalIcon } from './ProxyGoldMedalIcon-c0adb2f7.js';
import { P as ProxyAlcoholIcon } from './ProxyAlcoholIcon-9dce6c06.js';
import { P as ProxyClosureIcon } from './ProxyClosureIcon-c6c91da3.js';
import { P as ProxyRegionIcon } from './ProxyRegionIcon-9a27d51a.js';
import { P as ProxyVarietalIcon } from './ProxyVarietalIcon-df2eac6a.js';
import { P as ProxyStockIcon } from './ProxyStockIcon-3d92d956.js';
import { P as ProxyBuyerIcon } from './ProxyBuyerIcon-09e19967.js';
import { P as ProxyVolumeIcon } from './ProxyVolumeIcon-618c5c13.js';
import { P as ProxyPacksizeIcon } from './ProxyPacksizeIcon-f514f50a.js';
import { P as ProxyDashIcon } from './ProxyDashIcon-bab77266.js';
import { P as ProxyCellaringIcon } from './ProxyCellaringIcon-66d09ee8.js';
import { P as ProxyMoleculeIcon } from './ProxyMoleculeIcon-00839bba.js';
import { P as ProxyShakerIcon } from './ProxyShakerIcon-9e8f323f.js';
import { P as ProxyArrowRightIcon } from './ProxyArrowRightIcon-7100802b.js';
import { P as ProxyArrowDownIcon } from './ProxyArrowDownIcon-b5d4886d.js';
import { P as ProxyArrowUpIcon } from './ProxyArrowUpIcon-08cd4ff5.js';
import { P as ProxyArrowLeftIcon } from './ProxyArrowLeftIcon-9dea3429.js';
import { P as ProxyHistoryIcon } from './ProxyHistoryIcon-250df976.js';
import { P as ProxyTimeIcon } from './ProxyTimeIcon-1bedcb37.js';
import { P as ProxyPropertyLocationIcon } from './ProxyPropertyLocationIcon-3b8d31cf.js';
import { P as ProxyRoundDollarIcon } from './ProxyRoundDollarIcon-9500d81d.js';
import { P as ProxyCreditCardIcon } from './ProxyCreditCardIcon-b297d9c9.js';
import { P as ProxyPrinterIcon } from './ProxyPrinterIcon-59a9947f.js';
import { P as ProxyBarrelIcon } from './ProxyBarrelIcon-1e1e42bd.js';
import { P as ProxyGlassIcon } from './ProxyGlassIcon-35cb8084.js';
import { P as ProxyGrainIcon } from './ProxyGrainIcon-6aa42efc.js';
import { P as ProxyWineClubsIcon } from './ProxyWineClubsIcon-b1243065.js';
import { P as ProxyEmailIcon } from './ProxyEmailIcon-e662729e.js';
import { P as ProxyAddFriendIcon } from './ProxyAddFriendIcon-dad31af3.js';
import { P as ProxyExploreIcon } from './ProxyExploreIcon-a59a87f6.js';
import { P as ProxyEditIcon } from './ProxyEditIcon-d1057936.js';
import { P as ProxyRoundCheckIcon } from './ProxyRoundCheckIcon-7e7bbe9d.js';
import { P as ProxyRoundDeleteIcon } from './ProxyRoundDeleteIcon-371fce99.js';
import { P as ProxyRoundAddThinIcon } from './ProxyRoundAddThinIcon-068fa825.js';
import { P as ProxyCircleMinusIcon } from './ProxyCircleMinusIcon-8d3112ec.js';
import { P as ProxyLoopIcon } from './ProxyLoopIcon-951aa2a0.js';
import { P as ProxyPlusIcon } from './ProxyPlusIcon-448f3962.js';
import { P as ProxyLinkedInIcon } from './ProxyLinkedInIcon-9bc76869.js';
import { P as ProxyDenseIcon } from './ProxyDenseIcon-0ef9ae5a.js';
import { P as ProxyDryingIcon } from './ProxyDryingIcon-4582a267.js';
import { P as ProxyBricheIcon } from './ProxyBricheIcon-55d2c66f.js';
import { P as ProxyLeanIcon } from './ProxyLeanIcon-cec6a867.js';
import { P as ProxyLessyIcon } from './ProxyLessyIcon-0f3cfa29.js';
import { P as ProxyLemonGrassIcon } from './ProxyLemonGrassIcon-c76084d9.js';
import { P as ProxyTartIcon } from './ProxyTartIcon-e810ad8d.js';
import { P as ProxyTightIcon } from './ProxyTightIcon-e9ed1946.js';
import { P as ProxyTrashCanIcon } from './ProxyTrashCanIcon-2853e7ca.js';
import CopyIcon from './CopyIcon-9d5639ab.js';
import GiftIcon from './GiftIcon-72fd9114.js';
import GoldBannerIcon from './GoldBannerIcon-80739ecf.js';
import GoldRewardIcon from './GoldRewardIcon-d529253f.js';
import GoldRewardV2Icon from './GoldRewardV2Icon-503f99e1.js';
import GreenBannerIcon from './GreenBannerIcon-5f4b9f8f.js';
import GreenRewardIcon from './GreenRewardIcon-271dfb12.js';
import GreenRewardV2Icon from './GreenRewardV2Icon-ed59d13f.js';
import MultipleArrowsIcon from './MultipleArrowsIcon-c36ab7be.js';
import PlatinumBannerIcon from './PlatinumBannerIcon-95559587.js';
import RewardIcon from './RewardIcon-b7d1729f.js';
import SilverBannerIcon from './SilverBannerIcon-4f75054d.js';
import SilverRewardIcon from './SilverRewardIcon-a49daf0c.js';
import SilverRewardV2Icon from './SilverRewardV2Icon-1c63b0e0.js';
import { P as ProxyPopWineIcon } from './ProxyPopWineIcon-6cd1eb12.js';
import { P as ProxyDeliveryIcon } from './ProxyDeliveryIcon-2a3ec3d4.js';
import { P as ProxyRingIcon } from './ProxyRingIcon-60e997c2.js';
import { P as ProxyCakeIcon } from './ProxyCakeIcon-fa3be5b4.js';
import { P as ProxyThreeBottlesIcon } from './ProxyThreeBottlesIcon-b82a90f3.js';
import { P as ProxyUnwrapWineIcon } from './ProxyUnwrapWineIcon-acc483d8.js';
import { P as ProxyGiftBoxIcon } from './ProxyGiftBoxIcon-aa645c56.js';
import { P as ProxyPaperPlaneIcon } from './ProxyPaperPlaneIcon-612c3ff1.js';
import { P as ProxyShoppingCartIcon } from './ProxyShoppingCartIcon-f5890350.js';
import { P as ProxyCopyOutlineIcon } from './ProxyCopyOutlineIcon-d541ddfc.js';
import { P as ProxyDropletGreenVimIcon } from './ProxyDropletGreenVimIcon-28b368b3.js';
import { P as ProxyDropletSilverVimIcon } from './ProxyDropletSilverVimIcon-21f620a2.js';
import { P as ProxyDropletGoldVimIcon } from './ProxyDropletGoldVimIcon-fa3d88d5.js';
import { P as ProxyDropletBlackVimIcon } from './ProxyDropletBlackVimIcon-b44188d0.js';
import { P as ProxyBookletIcon } from './ProxyBookletIcon-33ed954a.js';

var ProxyBubblegumIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./BubblegumIcon-30ba6d15.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyReturnsThinIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./ReturnsThinIcon-ab4087d1.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyPriceTagIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./PriceTagIcon-2534be2c.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyPercentageStarIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./PercentageStarIcon-7a6e19ae.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyTruckThinIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./TruckThinIcon-6c3532df.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxySmileIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./SmileIcon-6df5c4ab.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyWineBottlesIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./WineBottlesIcon-de545829.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyLogoutIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./LogoutIcon-948ab77a.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyGoogleIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./GoogleIcon-f955c2db.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyHideShowPasswordIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./HideShowPasswordIcon-9647f5e7.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyWelcomeIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./WelcomeIcon-b4dc4a73.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyMofoYetIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./MofoYetIcon-04e85af0.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyPersonalisedIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./PersonalisedIcon-f586b949.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyWineDealsIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./WineDealsIcon-72955431.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxySpeedyCheckoutIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./SpeedyCheckoutIcon-eb12e5c5.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var PlatinumRewardIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 732 732" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M731.553 366.114V371.894H731.508C728.42 571.027 566.033 731.502 366.165 731.502C164.367 731.502 0.777339 567.912 0.777344 366.114C0.777348 164.316 164.367 0.726558 366.165 0.726563C370.352 0.726563 374.523 0.796991 378.676 0.936728L731.553 0.936728V366.114Z", fill: "#232627" }),
    React.createElement("path", { d: "M373.022 192.328H368.471H330.936H326.18L330.936 207.19V224.442V397.328V414.632L326.18 429.494H330.936H368.471H373.022L368.471 415.256V206.566L373.022 192.328Z", fill: "white" }),
    React.createElement("path", { d: "M276.562 191.273H272.732L275.353 199.718L274.698 204.119L272.732 217.17H272.833L257.914 320.601L256.553 330.53H254.486L253.075 320.601L238.207 217.17H238.307L236.695 206.832L235.687 199.667L238.257 191.273H234.477H198.238H196.625L202.421 217.17H202.522L236.896 426.54H274.143L308.517 217.17H308.568L314.364 191.273H312.751H276.562Z", fill: "white" }),
    React.createElement("path", { d: "M530.949 224.917V207.664L535.706 192.75H530.949H502.1H485.015L462.765 301.306L461.026 313.882H460.309L458.57 301.306L436.32 192.75H419.184H390.386H385.578L390.335 207.664V224.917H390.386V415.682L385.732 430.232H390.386H425.169H429.926L425.169 415.422V280.935V270.958H427.266L428.647 280.935L452.637 430.232H468.647L492.688 280.935L494.069 270.958H496.166V280.935V415.89L491.563 430.232H496.166H530.949H535.706L530.949 415.318V398.014V224.917Z", fill: "white" }),
    React.createElement("path", { d: "M114.604 462.256H126.462C130.463 462.256 133.464 463.33 135.465 465.477C137.465 467.624 138.466 470.771 138.466 474.919V479.969C138.466 484.117 137.465 487.264 135.465 489.411C133.464 491.558 130.463 492.632 126.462 492.632H122.656V513.492H114.604V462.256ZM126.462 485.312C127.779 485.312 128.755 484.946 129.39 484.215C130.073 483.483 130.414 482.238 130.414 480.482V474.407C130.414 472.65 130.073 471.406 129.39 470.674C128.755 469.942 127.779 469.576 126.462 469.576H122.656V485.312H126.462ZM186.023 462.256H194.074V506.173H207.322V513.492H186.023V462.256ZM260.875 462.256H271.781L280.125 513.492H272.074L270.61 503.318V503.465H261.461L259.997 513.492H252.531L260.875 462.256ZM269.659 496.511L266.072 471.186H265.926L262.412 496.511H269.659ZM330.151 469.576H321.734V462.256H346.62V469.576H338.203V513.492H330.151V469.576ZM393.703 462.256H401.754V513.492H393.703V462.256ZM450.969 462.256H461.069L468.901 492.925H469.048V462.256H476.221V513.492H467.95L458.288 476.09H458.142V513.492H450.969V462.256ZM537.1 514.224C533.197 514.224 530.22 513.126 528.171 510.93C526.121 508.686 525.096 505.49 525.096 501.342V462.256H533.148V501.928C533.148 503.684 533.489 504.953 534.173 505.734C534.905 506.514 535.929 506.905 537.247 506.905C538.564 506.905 539.565 506.514 540.248 505.734C540.98 504.953 541.346 503.684 541.346 501.928V462.256H549.104V501.342C549.104 505.49 548.079 508.686 546.03 510.93C543.981 513.126 541.004 514.224 537.1 514.224ZM598.023 462.256H609.515L614.638 498.927H614.784L619.908 462.256H631.4V513.492H623.787V474.699H623.641L617.785 513.492H611.052L605.196 474.699H605.05V513.492H598.023V462.256Z", fill: "white" }),
    React.createElement("path", { d: "M232.446 634.453C232.738 633.153 232.897 632.358 234.952 628.936L238.93 622.344C241.277 618.445 240.826 616.217 237.83 614.413L235.549 613.034L225.246 630.116L218.656 626.137L243.982 584.188L253.927 590.196C260.756 594.32 261.777 599.267 257.865 605.739L255.876 609.042C253.277 613.352 250.201 615.342 246.435 614.944C248.901 618.312 248.066 622.132 245.427 626.509L241.529 632.981C240.296 635.023 239.461 636.549 239.169 638.512L232.46 634.466L232.446 634.453ZM246.952 594.161L239.182 607.039L241.755 608.591C244.208 610.076 246.356 609.904 248.384 606.548L250.877 602.41C252.68 599.413 252.468 597.477 250.121 596.071L246.952 594.148V594.161Z", fill: "white" }),
    React.createElement("path", { d: "M277.754 624.972L287.606 628.779L285.087 635.304L275.235 631.498L270.077 644.88L282.475 649.667L279.956 656.193L260.371 648.633L277.993 602.93L297.578 610.476L295.058 617.001L282.661 612.214L277.754 624.946V624.972Z", fill: "white" }),
    React.createElement("path", { d: "M325 640.498L317.866 665.763L307.457 663.986L310.295 614.781L317.68 616.041L315.267 654.821L325.397 617.367L332.703 618.614L329.972 657.62L340.434 619.927L347.05 621.055L333.459 668.429L323.395 666.718L325.013 640.511L325 640.498Z", fill: "white" }),
    React.createElement("path", { d: "M386.59 669.469L378.834 669.695L377.242 660.849L367.802 661.127L366.728 670.053L359.66 670.265L366.065 621.074L377.322 620.742L386.59 669.469ZM368.584 654.456L375.996 654.244L371.567 629.588L368.584 654.456Z", fill: "white" }),
    React.createElement("path", { d: "M425.201 663.221C424.524 662.08 424.1 661.378 423.265 657.478L421.674 649.945C420.732 645.489 418.876 644.176 415.455 644.892L412.856 645.449L416.98 664.958L409.448 666.55L399.305 618.632L410.668 616.231C418.465 614.573 422.589 617.504 424.153 624.892L424.949 628.658C425.996 633.592 425.095 637.133 422.071 639.428C426.169 640.21 428.171 643.579 429.232 648.566L430.796 655.966C431.287 658.287 431.724 659.985 432.852 661.616L425.187 663.234L425.201 663.221ZM408.295 623.884L411.411 638.605L414.354 637.982C417.165 637.385 418.611 635.794 417.802 631.961L416.807 627.239C416.078 623.818 414.593 622.558 411.928 623.115L408.295 623.884Z", fill: "white" }),
    React.createElement("path", { d: "M436.923 609.185L448.181 604.556C455.301 601.625 460.419 604.145 463.39 611.386L472.804 634.291C475.787 641.532 473.918 646.93 466.797 649.848L455.54 654.477L436.91 609.171L436.923 609.185ZM446.696 612.726L459.995 645.087L464.013 643.442C466.28 642.514 467.155 640.79 465.829 637.554L456.15 613.999C454.824 610.763 452.981 610.153 450.713 611.095L446.696 612.739V612.726Z", fill: "white" }),
    React.createElement("path", { d: "M481.039 586.799C487.351 582.781 492.999 584.492 497.203 591.11L498.025 592.409L491.886 596.322L490.798 594.611C488.915 591.653 487.033 591.295 484.964 592.608C482.896 593.921 482.432 595.791 484.314 598.749C489.724 607.25 503.421 600.765 510.94 612.569C515.143 619.187 514.241 625.062 507.863 629.121C501.486 633.179 495.784 631.508 491.581 624.89L489.963 622.357L496.102 618.444L497.985 621.402C499.868 624.359 501.844 624.585 503.899 623.272C505.967 621.959 506.591 620.062 504.708 617.118C499.298 608.616 485.601 615.102 478.082 603.298C473.879 596.693 474.714 590.844 481.039 586.826V586.799Z", fill: "white" }))); };

var PlatinumRewardIcon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': PlatinumRewardIcon
});

var PlatinumRewardV2Icon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 327 327" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M327 163.385V165.824H326.98C325.601 254.79 253.052 326.484 163.758 326.484C73.6017 326.484 0.515623 253.398 0.515625 163.242C0.515627 73.086 73.6017 -1.97043e-06 163.758 0C165.627 4.08473e-08 167.489 0.0314096 169.342 0.0937297L327 0.0937297V163.1C327 163.147 327 163.195 327 163.242C327 163.29 327 163.337 327 163.385Z", fill: "#232627" }),
    React.createElement("path", { d: "M53.6197 198.719H60.9097C63.3697 198.719 65.2147 199.379 66.4447 200.699C67.6747 202.019 68.2897 203.954 68.2897 206.504V209.609C68.2897 212.159 67.6747 214.094 66.4447 215.414C65.2147 216.734 63.3697 217.394 60.9097 217.394H58.5697V230.219H53.6197V198.719ZM60.9097 212.894C61.7197 212.894 62.3197 212.669 62.7097 212.219C63.1297 211.769 63.3397 211.004 63.3397 209.924V206.189C63.3397 205.109 63.1297 204.344 62.7097 203.894C62.3197 203.444 61.7197 203.219 60.9097 203.219H58.5697V212.894H60.9097ZM84.4781 198.719H89.4281V225.719H97.5731V230.219H84.4781V198.719ZM117.448 198.719H124.153L129.283 230.219H124.333L123.433 223.964V224.054H117.808L116.908 230.219H112.318L117.448 198.719ZM122.848 219.779L120.643 204.209H120.553L118.393 219.779H122.848ZM146.989 203.219H141.814V198.719H157.114V203.219H151.939V230.219H146.989V203.219ZM173.01 198.719H177.96V230.219H173.01V198.719ZM195.168 198.719H201.378L206.193 217.574H206.283V198.719H210.693V230.219H205.608L199.668 207.224H199.578V230.219H195.168V198.719ZM235.072 230.669C232.672 230.669 230.842 229.994 229.582 228.644C228.322 227.264 227.692 225.299 227.692 222.749V198.719H232.642V223.109C232.642 224.189 232.852 224.969 233.272 225.449C233.722 225.929 234.352 226.169 235.162 226.169C235.972 226.169 236.587 225.929 237.007 225.449C237.457 224.969 237.682 224.189 237.682 223.109V198.719H242.452V222.749C242.452 225.299 241.822 227.264 240.562 228.644C239.302 229.994 237.472 230.669 235.072 230.669ZM259.477 198.719H266.542L269.692 221.264H269.782L272.932 198.719H279.997V230.219H275.317V206.369H275.227L271.627 230.219H267.487L263.887 206.369H263.797V230.219H259.477V198.719Z", fill: "white" }),
    React.createElement("path", { d: "M166.809 85.125H164.799H148.218H146.117L148.218 91.69V99.3108V175.68V183.324L146.117 189.889H148.218H164.799H166.809L164.799 183.599V91.4145L166.809 85.125Z", fill: "white" }),
    React.createElement("path", { d: "M123.538 85.125H121.831L122.999 88.8857L122.707 90.8459L121.831 96.6579H121.876L115.226 142.721L114.619 147.143H113.698L113.069 142.721L106.441 96.6579H106.486L105.767 92.0539L105.318 88.8629L106.464 85.125H104.779H88.6252H87.9062L90.4899 96.6579H90.5349L105.857 189.901H122.46L137.782 96.6579H137.805L140.388 85.125H139.67H123.538Z", fill: "white" }),
    React.createElement("path", { d: "M237.449 99.3168V91.705L239.548 85.125H237.449H224.721H217.184L207.367 133.019L206.6 138.568H206.284L205.516 133.019L195.699 85.125H188.139H175.434H173.312L175.411 91.705V99.3168H175.434V183.482L173.38 189.901H175.434H190.78H192.878L190.78 183.367V124.032V119.63H191.705L192.314 124.032L202.898 189.901H209.962L220.569 124.032L221.178 119.63H222.103V124.032V183.573L220.072 189.901H222.103H237.449H239.548L237.449 183.321V175.686V99.3168Z", fill: "white" }))); };

var PlatinumRewardV2Icon$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': PlatinumRewardV2Icon
});

var ProxyStarOutlineIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./StarOutlineIcon-c2b1bb4e.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var ProxyStarIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./StarIcon-844ee8ce.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

var map = {
    cart: ProxyCartIcon,
    close: ProxyCloseIcon,
    "location-pin": ProxyLocationPinIcon,
    phone: ProxyPhoneIcon,
    chat: ProxyChatIcon,
    globe: ProxyGlobeIcon,
    "external-link": ExternalLinkIcon,
    search: ProxySearchIcon,
    toggle: ProxyToggleIcon,
    user: ProxyUserIcon,
    truck: ProxyTruckIcon,
    tag: ProxyTagIcon,
    tarragon: ProxyTarragonIcon,
    returns: ProxyReturnsIcon,
    youtube: ProxyYoutubeIcon,
    twitter: ProxyTwitterIcon,
    instagram: ProxyInstagramIcon,
    facebook: ProxyFacebookIcon,
    bright: ProxyBrightIcon,
    chalky: ProxyChalkyIcon,
    chewy: ProxyChewyIcon,
    crisp: ProxyCrispIcon,
    fine: ProxyFineIcon,
    firm: ProxyFirmIcon,
    flat: ProxyFlatIcon,
    fresh: ProxyFreshIcon,
    grippy: ProxyGrippyIcon,
    lively: ProxyLivelyIcon,
    mellow: ProxyMellowIcon,
    "mouth-watering": ProxyMouthWateringIcon,
    racy: ProxyRacyIcon,
    refreshing: ProxyRefreshingIcon,
    round: ProxyRoundIcon,
    rustic: ProxyRusticIcon,
    silky: ProxySilkyIcon,
    smooth: ProxySmoothIcon,
    soft: ProxySoftIcon,
    textured: ProxyTexturedIcon,
    velvety: ProxyVelvetyIcon,
    vibrant: ProxyVibrantIcon,
    zesty: ProxyZestyIcon,
    zippy: ProxyZippyIcon,
    "full-bodied": ProxyFullBodiedIcon,
    "medium-bodied": ProxyMediumBodiedIcon,
    "light-bodied": ProxyLightBodiedIcon,
    bold: ProxyBoldIcon,
    bramble: ProxyBrambleIcon,
    concentrated: ProxyConcentratedIcon,
    deep: ProxyDeepIcon,
    delicate: ProxyDelicateIcon,
    elegant: ProxyElegantIcon,
    ethereal: ProxyEtherealIcon,
    intense: ProxyIntenseIcon,
    opulent: ProxyOpulentIcon,
    powerful: ProxyPowerfulIcon,
    refined: ProxyRefinedIcon,
    restrained: ProxyRestrainedIcon,
    rich: ProxyRichIcon,
    robust: ProxyRobustIcon,
    allspice: ProxyAllspiceIcon,
    almond: ProxyAlmondIcon,
    anise: ProxyAniseedIcon,
    aniseed: ProxyAniseedIcon,
    apple: ProxyAppleIcon,
    apricot: ProxyApricotIcon,
    asparagus: ProxyAsparagusIcon,
    banana: ProxyBananaIcon,
    basil: ProxyBasilIcon,
    "bay-leaf": ProxyBayLeafIcon,
    bell: ProxyBellIcon,
    "bell-rung": ProxyBellRungIcon,
    berries: ProxyBerriesIcon,
    biscuity: ProxyBiscuityIcon,
    "black-cherry": ProxyBlackCherryIcon,
    "black-olive": ProxyBlackOliveIcon,
    blackberry: ProxyBlackberryIcon,
    blackcurrant: ProxyBlackcurrantIcon,
    "blood-plum": ProxyBloodPlumIcon,
    blossoms: ProxyBlossomsIcon,
    blueberry: ProxyBlueberryIcon,
    "boiled-lollies": ProxyBoiledLolliesIcon,
    bread: ProxyBreadIcon,
    briary: ProxyBriaryIcon,
    briny: ProxyBrinyIcon,
    brioche: ProxyBriocheIcon,
    bubblegum: ProxyBubblegumIcon,
    butterscotch: ProxyButterscotchIcon,
    buttery: ProxyButteryIcon,
    candied: ProxyCandiedIcon,
    capsicum: ProxyCapsicumIcon,
    caramel: ProxyCaramelIcon,
    cashew: ProxyCashewIcon,
    cassis: ProxyCassisIcon,
    cedar: ProxyCedarIcon,
    charred: ProxyCharredIcon,
    cherry: ProxyCherryIcon,
    chestnut: ProxyChestnutIcon,
    chocolate: ProxyChocolateIcon,
    cigarbox: ProxyCigarboxIcon,
    cinnamon: ProxyCinnamonIcon,
    citrus: ProxyCitrusIcon,
    cloves: ProxyClovesIcon,
    cocoa: ProxyCocoaIcon,
    coconut: ProxyCoconutIcon,
    cola: ProxyColaIcon,
    coffee: ProxyCoffeeIcon,
    "coffee-beans": ProxyCoffeeIcon,
    cranberry: ProxyCranberryIcon,
    creamy: ProxyCreamyIcon,
    cucumber: ProxyCucumberIcon,
    cumquat: ProxyCumquatIcon,
    "dark-chocolate": ProxyDarkChocolateIcon,
    dill: ProxyDillIcon,
    "dried-apricot": ProxyDriedApricotIcon,
    "dried-flowers": ProxyDriedFlowersIcon,
    earthy: ProxyEarthyIcon,
    elderflower: ProxyElderflowerIcon,
    eucalyptus: ProxyEucalyptusIcon,
    feijoa: ProxyFeijoaIcon,
    fennel: ProxyFennelIcon,
    fig: ProxyFigIcon,
    flinty: ProxyFlintyIcon,
    floral: ProxyFloralIcon,
    "forest-floor": ProxyForestFloorIcon,
    "fruit-salad": ProxyFruitSaladIcon,
    fruitcake: ProxyFruitcakeIcon,
    fruity: ProxyFruityIcon,
    gamey: ProxyGameyIcon,
    geranium: ProxyGeraniumIcon,
    gingerbread: ProxyGingerbreadIcon,
    gooseberry: ProxyGooseberryIcon,
    grapefruit: ProxyGrapefruitIcon,
    grassy: ProxyGrassyIcon,
    "green-apple": ProxyGreenAppleIcon,
    "green-olive": ProxyGreenOliveIcon,
    guava: ProxyGuavaIcon,
    hay: ProxyHayIcon,
    hazelnut: ProxyHazelnutIcon,
    herbaceous: ProxyHerbaceousIcon,
    honey: ProxyHoneyIcon,
    honeysuckle: ProxyHoneysuckleIcon,
    hot: ProxyHotIcon,
    jammy: ProxyJammyIcon,
    jasmine: ProxyJasmineIcon,
    jubie: ProxyJubieIcon,
    "kaffir-lime": ProxyKaffirLimeIcon,
    kerosene: ProxyKeroseneIcon,
    "kiwi-fruit": ProxyKiwiFruitIcon,
    lanolin: ProxyLanolinIcon,
    "laser-like": ProxyLaserLikeIcon,
    lavender: ProxyLavenderIcon,
    leather: ProxyLeatherIcon,
    leesy: ProxyLeesyIcon,
    "lemon-zest": ProxyLemonZestIcon,
    lemon: ProxyLemonIcon,
    "lemon-curd": ProxyLemonCurdIcon,
    licorice: ProxyLicoriceIcon,
    lime: ProxyLimeIcon,
    "lime-cordial": ProxyLimeCordialIcon,
    lychee: ProxyLycheeIcon,
    malty: ProxyMaltyIcon,
    mandarin: ProxyMandarinIcon,
    mango: ProxyMangoIcon,
    marmalade: ProxyMarmaladeIcon,
    marzipan: ProxyMarzipanIcon,
    meaty: ProxyMeatyIcon,
    medicinal: ProxyMedicinalIcon,
    melon: ProxyMelonIcon,
    menthol: ProxyMentholIcon,
    minerally: ProxyMinerallyIcon,
    mint: ProxyMintIcon,
    mocha: ProxyMochaIcon,
    molasses: ProxyMolassesIcon,
    mossy: ProxyMossyIcon,
    mulberry: ProxyMulberryIcon,
    mushroom: ProxyMushroomIcon,
    musk: ProxyMuskIcon,
    nectarine: ProxyNectarineIcon,
    nettles: ProxyNettlesIcon,
    nougat: ProxyNougatIcon,
    nutmeg: ProxyNutmegIcon,
    nutty: ProxyNuttyIcon,
    oaky: ProxyOakyIcon,
    "off-dry": ProxyOffDryIcon,
    "orange-peel": ProxyOrangePeelIcon,
    orange: ProxyOrangeIcon,
    "orange-blossom": ProxyOrangeBlossomIcon,
    "oyster-shell": ProxyOysterShellIcon,
    passionfruit: ProxyPassionfruitIcon,
    peach: ProxyPeachIcon,
    pear: ProxyPearIcon,
    peas: ProxyPeasIcon,
    "pencil-shavings": ProxyPencilShavingsIcon,
    pepper: ProxyPepperIcon,
    peppermint: ProxyPeppermintIcon,
    perfumed: ProxyPerfumedIcon,
    pine: ProxyPineIcon,
    pineapple: ProxyPineappleIcon,
    pithy: ProxyPithyIcon,
    plum: ProxyPlumIcon,
    popcorn: ProxyPopcornIcon,
    potpourri: ProxyPotpourriIcon,
    prunes: ProxyPrunesIcon,
    quince: ProxyQuinceIcon,
    raisin: ProxyRaisinIcon,
    raspberry: ProxyRaspberryIcon,
    redcurrant: ProxyRedcurrantIcon,
    rhubarb: ProxyRhubarbIcon,
    rockmelon: ProxyRockmelonIcon,
    "rose-petal": ProxyRosePetalIcon,
    saffron: ProxySaffronIcon,
    sage: ProxySageIcon,
    salty: ProxySaltyIcon,
    sandalwood: ProxySandalwoodIcon,
    savoury: ProxySavouryIcon,
    "sea-spray": ProxySeaSprayIcon,
    slate: ProxySlateIcon,
    smoky: ProxySmokyIcon,
    "sour-cherry": ProxySourCherryIcon,
    soy: ProxySoyIcon,
    spearmint: ProxySpearmintIcon,
    spice: ProxySpiceIcon,
    spicebox: ProxySpiceboxIcon,
    "star-anise": ProxyStarAniseIcon,
    "stewed-fruits": ProxyStewedFruitsIcon,
    strawberry: ProxyStrawberryIcon,
    "struck-match": ProxyStruckMatchIcon,
    structured: ProxyStructuredIcon,
    sweet: ProxySweetIcon,
    tarry: ProxyTarryIcon,
    tea: ProxyTeaIcon,
    "tea-leaf": ProxyTeaLeafIcon,
    temp: ProxyTempIcon,
    thyme: ProxyThymeIcon,
    toast: ProxyToastIcon,
    tobacco: ProxyTobaccoIcon,
    toffee: ProxyToffeeIcon,
    "tomato-leaf": ProxyTomatoLeafIcon,
    treacle: ProxyTreacleIcon,
    "tropical-fruit": ProxyTropicalFruitIcon,
    truffle: ProxyTruffleIcon,
    umami: ProxyUmamiIcon,
    unoaked: ProxyUnoakedIcon,
    vanilla: ProxyVanillaIcon,
    vegemite: ProxyVegemiteIcon,
    vegetative: ProxyVegetativeIcon,
    violets: ProxyVioletsIcon,
    walnut: ProxyWalnutIcon,
    "white-peach": ProxyWhitePeachIcon,
    "white-pepper": ProxyWhitePepperIcon,
    "wild-berries": ProxyWildBerriesIcon,
    woody: ProxyWoodyIcon,
    yeasty: ProxyYeastyIcon,
    yoghurt: ProxyYoghurtIcon,
    "points-90": ProxyPoints90Icon,
    "points-91": ProxyPoints91Icon,
    "points-92": ProxyPoints92Icon,
    "points-93": ProxyPoints93Icon,
    "points-94": ProxyPoints94Icon,
    "points-95": ProxyPoints95Icon,
    "points-96": ProxyPoints96Icon,
    "points-97": ProxyPoints97Icon,
    "points-98": ProxyPoints98Icon,
    "points-99": ProxyPoints99Icon,
    "points-100": ProxyPoints100Icon,
    "gold-medal": ProxyGoldMedalIcon,
    alcohol: ProxyAlcoholIcon,
    closure: ProxyClosureIcon,
    region: ProxyRegionIcon,
    varietal: ProxyVarietalIcon,
    stock: ProxyStockIcon,
    buyer: ProxyBuyerIcon,
    volume: ProxyVolumeIcon,
    packsize: ProxyPacksizeIcon,
    dash: ProxyDashIcon,
    cellaring: ProxyCellaringIcon,
    molecule: ProxyMoleculeIcon,
    shaker: ProxyShakerIcon,
    "arrow-right": ProxyArrowRightIcon,
    "arrow-down": ProxyArrowDownIcon,
    "arrow-up": ProxyArrowUpIcon,
    "arrow-left": ProxyArrowLeftIcon,
    history: ProxyHistoryIcon,
    time: ProxyTimeIcon,
    "property-location": ProxyPropertyLocationIcon,
    "round-dollar": ProxyRoundDollarIcon,
    "credit-card": ProxyCreditCardIcon,
    "returns-thin": ProxyReturnsThinIcon,
    "printer-icon": ProxyPrinterIcon,
    barrel: ProxyBarrelIcon,
    glass: ProxyGlassIcon,
    grain: ProxyGrainIcon,
    "price-tag": ProxyPriceTagIcon,
    "percentage-star": ProxyPercentageStarIcon,
    "truck-thin": ProxyTruckThinIcon,
    smile: ProxySmileIcon,
    "wine-bottles": ProxyWineBottlesIcon,
    "wine-clubs": ProxyWineClubsIcon,
    email: ProxyEmailIcon,
    "add-friend": ProxyAddFriendIcon,
    "log-out": ProxyLogoutIcon,
    explore: ProxyExploreIcon,
    edit: ProxyEditIcon,
    "round-check": ProxyRoundCheckIcon,
    "round-delete": ProxyRoundDeleteIcon,
    "round-add-thin": ProxyRoundAddThinIcon,
    "circle-minus": ProxyCircleMinusIcon,
    loop: ProxyLoopIcon,
    plus: ProxyPlusIcon,
    "linked-in": ProxyLinkedInIcon,
    google: ProxyGoogleIcon,
    "hide-show-password": ProxyHideShowPasswordIcon,
    welcome: ProxyWelcomeIcon,
    "mofo-yet": ProxyMofoYetIcon,
    personalised: ProxyPersonalisedIcon,
    "wine-deals": ProxyWineDealsIcon,
    "speedy-checkout": ProxySpeedyCheckoutIcon,
    dense: ProxyDenseIcon,
    drying: ProxyDryingIcon,
    lean: ProxyLeanIcon,
    lessy: ProxyLessyIcon,
    "lemon-grass": ProxyLemonGrassIcon,
    tart: ProxyTartIcon,
    tight: ProxyTightIcon,
    briche: ProxyBricheIcon,
    "trash-can": ProxyTrashCanIcon,
    copy: CopyIcon,
    gift: GiftIcon,
    "gold-banner": GoldBannerIcon,
    "gold-reward": GoldRewardIcon,
    "gold-reward-v2": GoldRewardV2Icon,
    "green-banner": GreenBannerIcon,
    "green-reward": GreenRewardIcon,
    "green-reward-v2": GreenRewardV2Icon,
    "multiple-arrows": MultipleArrowsIcon,
    "platinum-banner": PlatinumBannerIcon,
    "platinum-reward": PlatinumRewardIcon,
    "platinum-reward-v2": PlatinumRewardV2Icon,
    reward: RewardIcon,
    "silver-banner": SilverBannerIcon,
    "silver-reward": SilverRewardIcon,
    "silver-reward-v2": SilverRewardV2Icon,
    "pop-wine": ProxyPopWineIcon,
    delivery: ProxyDeliveryIcon,
    ring: ProxyRingIcon,
    cake: ProxyCakeIcon,
    "three-bottles": ProxyThreeBottlesIcon,
    "unwrap-wine": ProxyUnwrapWineIcon,
    "paper-plane": ProxyPaperPlaneIcon,
    "gift-box": ProxyGiftBoxIcon,
    "shopping-cart": ProxyShoppingCartIcon,
    "copy-outline": ProxyCopyOutlineIcon,
    "droplet-green-vim": ProxyDropletGreenVimIcon,
    "droplet-silver-vim": ProxyDropletSilverVimIcon,
    "droplet-gold-vim": ProxyDropletGoldVimIcon,
    "droplet-black-vim": ProxyDropletBlackVimIcon,
    "star-outline": ProxyStarOutlineIcon,
    star: ProxyStarIcon,
    booklet: ProxyBookletIcon,
};

var ProxyIcon = function (_a) {
    var iconName = _a.iconName, size = _a.size, isClicked = _a.isClicked;
    var icon = map[iconName];
    if (icon) {
        return React.createElement(icon, { size: size, isClicked: isClicked });
    }
    return React.createElement(UnavailableIcon, { size: size, isClicked: isClicked });
};

export { ProxyBubblegumIcon as P, ProxyReturnsThinIcon as a, ProxyPriceTagIcon as b, ProxyPercentageStarIcon as c, ProxyTruckThinIcon as d, ProxySmileIcon as e, ProxyWineBottlesIcon as f, ProxyLogoutIcon as g, ProxyGoogleIcon as h, ProxyHideShowPasswordIcon as i, ProxyWelcomeIcon as j, ProxyMofoYetIcon as k, ProxyPersonalisedIcon as l, ProxyWineDealsIcon as m, ProxySpeedyCheckoutIcon as n, PlatinumRewardIcon as o, PlatinumRewardV2Icon as p, ProxyStarOutlineIcon as q, ProxyStarIcon as r, ProxyIcon as s, PlatinumRewardIcon$1 as t, PlatinumRewardV2Icon$1 as u };
